import img2 from "./20241115_194737.jpg";
import img3 from "./20241115_192823.jpg";
import img4 from "./20241115_192416.jpg";
import img5 from "./20241115_192227.jpg";
import img6 from "./20241114_135302.jpg";
import img7 from "./20241114_135112.jpg";
import img8 from "./20241114_134858.jpg";

const casaImages = [
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
];

export default casaImages;